import axios from 'axios';
import { PROVIDER_API_URL } from '../utils/urls';

const PROVIDER_API_TOKEN = '8a0b1d6ee0c33ee0b5a663ecce6288a46455f2a4a65f458f095bbd40aab552fb';

// Configure axios with default headers
const apiClient = axios.create({
  headers: {
    'x-api-token': PROVIDER_API_TOKEN
  }
});

export const getParticipationMatrix2Data = async (filters = {}) => {
  try {
    const response = await apiClient.get(`${PROVIDER_API_URL}/api/participation-matrix`);
    return response.data;
  } catch (error) {
    console.error('Error fetching providers:', error);
    throw error;
  }
};